import * as ambassadorWixCloudResourceusageV1ResourceUsage from './cloud-resourceusage-v1-resource-usage-data.http.js';
import * as ambassadorWixCloudResourceusageV1ResourceUsageTypes from './cloud-resourceusage-v1-resource-usage-data.types.js';
import * as ambassadorWixCloudResourceusageV1ResourceUsageUniversalTypes from './cloud-resourceusage-v1-resource-usage-data.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getResourceUsage(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixCloudResourceusageV1ResourceUsageUniversalTypes.GetResourceUsageRequest,
  ambassadorWixCloudResourceusageV1ResourceUsageTypes.GetResourceUsageRequest,
  ambassadorWixCloudResourceusageV1ResourceUsageUniversalTypes.GetResourceUsageResponse,
  ambassadorWixCloudResourceusageV1ResourceUsageTypes.GetResourceUsageResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixCloudResourceusageV1ResourceUsage.getResourceUsage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/resource-usage',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ResourceUsage as ResourceUsageOriginal,
  DataCollectionResourceUsage as DataCollectionResourceUsageOriginal,
  CollectionType as CollectionTypeOriginal,
  CollectionTypeWithLiterals as CollectionTypeWithLiteralsOriginal,
  GetResourceUsageRequest as GetResourceUsageRequestOriginal,
  GetResourceUsageResponse as GetResourceUsageResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
} from './cloud-resourceusage-v1-resource-usage-data.types.js';
